import React from 'react';
import { bool } from 'prop-types';

import { InputField } from '../../../../components';

export const PhoneField = ({ countryUSA, onlyDashesFormat, ...rest }) => {
  if (onlyDashesFormat) {
    return (
      <InputField
        {...rest}
        errorText={() => 'Enter a valid phone number in XXX-XXX-XXXX format'}
        mask='phone'
        maxLength={12}
        minLength={12}
        pattern='^\d{3}-\d{3}-\d{4}$'
        type='tel'
        onlyDashesFormat
      />
    );
  }
  return (
    <InputField
      {...rest}
      errorText={() =>
        `Enter valid phone number ${countryUSA ? 'eg: (xxx) xxx-xxxx' : ''}`
      }
      label={rest.label}
      mask={countryUSA && 'phone'}
      maxLength={15}
      minLength={10}
      pattern={
        countryUSA
          ? '^(?=.*?[1-9]).{13,}[0-9 ()+-]+$'
          : '^(?=.*?[1-9])[0-9 ()+-]+$'
      }
      type='tel'
    />
  );
};

PhoneField.propTypes = {
  countryUSA: bool,
  onlyDashesFormat: bool,
};
